// "(A01) Name" → letter A, number 1. Missing rolls sort last.
function rollSortKey(name) {
  const match = String(name || '').match(/\(\s*([A-Za-z]*)\s*(\d*)\s*\)/);
  if (!match || (!match[1] && !match[2])) return null;
  return {
    letter: match[1].toUpperCase(),
    number: match[2] ? parseInt(match[2], 10) : -1
  };
}

function studentName(value) {
  if (value && typeof value === 'object') return value.student_name || value.name || '';
  return value;
}

// A01, A02, A03, A08, then B01. The number is numeric, so A2 precedes A10.
// Two papers with the same roll stay in name order. A name with no roll goes last.
export function compareStudentsByRoll(a, b) {
  const nameA = String(studentName(a) || '');
  const nameB = String(studentName(b) || '');
  const rollA = rollSortKey(nameA);
  const rollB = rollSortKey(nameB);
  if (!rollA && !rollB) return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
  if (!rollA) return 1;
  if (!rollB) return -1;
  const letter = rollA.letter.localeCompare(rollB.letter);
  if (letter !== 0) return letter;
  if (rollA.number !== rollB.number) return rollA.number - rollB.number;
  return nameA.localeCompare(nameB, undefined, { sensitivity: 'base' });
}
